<template>

  <div id="md-layout md-gutter md-alignment-center">

    <md-dialog-alert
      :md-active.sync="messageTip.show"
      :md-title="messageTip.title"
      :md-content="messageTip.msg"
      md-confirm-text="Ok"/>

    <md-app>
      <md-app-toolbar class="md-primary" md-elevation="0">
        <md-button class="md-icon-button" @click="toggleMenu" v-if="!menuVisible">
          <md-icon>menu</md-icon>
        </md-button>

        <span class="md-title">{{pageTitle}}</span>

        <div class="md-toolbar-section-end">
          <md-button @click="logout">
            <md-icon>exit_to_app</md-icon>
          </md-button>
        </div>
      </md-app-toolbar>

      <md-app-drawer :md-active.sync="menuVisible" md-swipeable>
        <md-toolbar class="md-transparent" md-elevation="0">
          <span>Навигация</span>

          <div class="md-toolbar-section-end">
            <md-button class="md-icon-button md-dense" @click="toggleMenu">
              <md-icon>keyboard_arrow_left</md-icon>
            </md-button>
          </div>
        </md-toolbar>

        <md-list>

          <md-list-item @click="to('/user_logs')">
            <md-icon>event_note</md-icon>
            <span class="md-list-item-text">Журнал операций</span>
          </md-list-item>

          <md-list-item @click="to('/search')">
            <md-icon>search</md-icon>
            <span class="md-list-item-text">Поиск заказов</span>
          </md-list-item>

          <md-list-item v-if="user && (user.role === 'admin'|| user.role === 'manager')" @click="to('/logs')">
            <md-icon>event_seat</md-icon>
            <span class="md-list-item-text">История(админ)</span>
          </md-list-item>

          <md-list-item v-if="user && (user.role === 'admin' || user.role === 'manager')" @click="to('/courier_management')">
            <md-icon>supervisor_account</md-icon>
            <span class="md-list-item-text">Пользователи</span>
          </md-list-item>
        </md-list>
      </md-app-drawer>

      <md-app-content>

        <div v-if="!wsConnect.connect && !wsConnect.error">
          <span class="md-title">Загрузка...</span>
          <md-progress-bar md-mode="query"/>
        </div>

        <div v-else>
          <router-view/>
        </div>

      </md-app-content>
    </md-app>

  </div>
</template>

<script>
  export default {
    name: 'app',
    data() {
      return {
        menuVisible: false
      }
    },
    methods: {
      toggleMenu() {
        this.menuVisible = !this.menuVisible
      },
      to(url) {
        this.$router.push({path: url});
        this.menuVisible = false
      },
      errorMessage(error) {
        return this.$store.getters.getErrorMessage(error)
      },
      logout() {
        document.cookie = "courierx" + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        this.$store.getters.getWSConnectState.ws.close();
      }
    },
    computed: {
      pageTitle: function () {
        return this.$route.meta.title
      },
      wsConnect() {
        return this.$store.getters.getWSConnectState
      },
      messageTip() {
        let msg = this.$store.getters.getMessageByMethod('SussesSetStatus');

        if (msg.event === "setOrderTransferStatus") {
          this.$router.push({path: "/search"});
          msg.msg = "Заказ успешно перенесен.";
        }

        return msg
      },
      user() {
        return this.$store.getters.getUser
      },
    },
    components: {}
  }
</script>

<style>
  .md-content {
    padding-left: 15px;
  }

  .md-table, .md-table-content {
    padding-left: 0px;
  }

  .md-input.md-input.md-select-value {
    padding-left: 15px;
  }

  .md-app {
    min-height: 350px;
    border: 0 solid rgba(0, 0, 0, 0.12);
  }

  .md-drawer {
    width: 230px;
    max-width: calc(100vw - 95px);
  }

  a {
    text-decoration: none !important;
  }

  .md-toolbar-section-end .md-button {
    min-width: 35px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue